<template>
  <div>
    <app-header messages="登录" pathName="/login/login"></app-header>
    <!--login-->
    <div class="w" @mouseover="changes">
      <div class="wb">
        <div class="login_box bg_w_s t_c">
          <div class="login_logo">
            <img src="/static/images/logo.png" alt />
          </div>
          <form action>
            <ul>
              <li class="login_tit">
                <a href="javascript:;" @click="swatchRoute('login')" :class="{now:status}">验证码登录</a>
                <a href="javascript:;" @click="swatchRoute('loginuser')" :class="{now:!status}">账号登录</a>
              </li>
              <li class="sec_word">新用户首次登录将自动注册新帐号</li>
              <li class="phone_input">
                <em>+86</em>
                <input type="text" class="input_40 bt_nom" placeholder="请输入手机号" v-model="account" />
              </li>
              <li class="login_bt130">
                <input
                  type="text"
                  class="input_40 login_yzm"
                  maxlength="4"
                  placeholder="请输验证码"
                  v-model="verifyCode"
                />
                <i v-if="type === 1">
                  <a href="javascript:;" class="bt bt_40 bt_1 bt_nom" @click="sendCode">{{message}}</a>
                </i>
                <i v-else>
                  <a href="javascript:;" class="bt bt_40 bt_5 bt_nom">{{message}}</a>
                </i>
              </li>
              <li class="login_btb">
                <button
                  v-if="hidden === 1"
                  class="bt bt_50 bt_1 bt_nom"
                  @click.prevent="submit()"
                >{{loginAccount}}</button>
                <button v-else-if="hidden === 2" class="bt bt_50 bt_5 bt_nom">{{loginAccount}}</button>
              </li>
              <li>
                <router-link
                  to="/register/register"
                  class="link_word"
                  :target="isApps === 1 ? '':'_blank'"
                >新用户注册</router-link>
              </li>
              <ThirdLogin></ThirdLogin>
            </ul>
          </form>
        </div>
      </div>
    </div>
    <i v-if="this.errorMessage !== ''">
      <div style="margin-top:75px;" class="jump_tips_error">{{errorMessage}}</div>
    </i>
    <app-footer></app-footer>
    <!--login end-->
  </div>
</template>
<script>
import AppHeader from "../../components/common/Header.vue";
import AppFooter from "../../components/common/Footer.vue";
import ThirdLogin from "./thirdLogin.vue"
export default {
  name: "login",
  props: ["messages", "messageStatus"],
  components: {
    AppHeader,
    AppFooter,
    ThirdLogin
  },
  metaInfo: {
    title: "验证码登录 - 租罗记",
    meta: [
      {
        name: "keywords",
        content: "验证码登录,租罗记",
      },
      {
        name: "description",
        content: "验证码登录,租罗记,租电脑,租办公服务器",
      },
    ],
  },
  data() {
    return {
      account: "",
      verifyCode: "",
      status: true,
      message: "获取验证码",
      time: 0,
      loginAccount: "登录",
      pathInfo: "",
      productId: "",
      type: 1,
      errorMessage: "",
      isregister: "yes",
      hidden: 1,
      isApps: "",
      universalCode: false,
      ip: "", //ip地址
    };
  },
  created() {
    let isApp = this.appConfig.checkBoxs.checkBox();
    if (isApp === "browser") {
      this.isApps = 1;
    } else if (isApp === "app") {
      this.isApps = 2;
    }
    this.ip = returnCitySN["cip"];
    this.utils.user.token.del(); //只要到登录页就清楚token信息
    this.utils.user.expiryTime.del(); //只要到登录页就清楚过期时间信息
    localStorage.removeItem("info");
    localStorage.removeItem("select");
    localStorage.removeItem("code");
    if (this.$route.name === "login") {
      this.status = true;
    }
    if (this.inWeixin) {
      let obj = JSON.parse(window.localStorage.getItem('shopPathInfo'))
      this.productId = obj['productId'];
      this.pathInfo = obj['pathInfo'];
    } else {
      this.productId = this.$route.params.productId
      this.pathInfo = this.$route.params.pathInfo
    }
    window.localStorage.removeItem("user-info");
  },
  methods: {
    // 切换页面
    swatchRoute(name) {
      this.$router.push({
        name: name,
        params: { productId: this.productId, pathInfo: this.pathInfo },
      });
    },
    //验证手机号码部分
    sendCode() {
      this.universalCode = true;
      var reg = 11 && /^((13|14|15|17|18|19|16|12|11|10)[0-9]{1}\d{8})$/;
      if (this.account === "") {
        this.errorMessage = "请输入手机号码";
        return false;
      } else if (!reg.test(this.account)) {
        this.errorMessage = "手机格式不正确";
        return false;
      } else {
        this.time = 50;
        this.type = 2;
        this.timer();
      }
      //发送验证码
      let apiUrl =
        this.appConfig.apiHost + "/v1/app/customer/send-verify-code/";
      let data = {
        account: this.account,
        action: "login",
      };
      let that = this;
      that.axios.post(apiUrl, data).then(function (response) {
        if (response.status === 200 && response.data.code === 200) {
          that.isregister = response.data.data.isregister;
        } else {
          that.errorMessage = "短信发送次数过多，请1小时后再尝试或联系客服";
          that.time = 0;
        }
      });
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.message = this.time + "s";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.type = 1;
        this.message = "获取验证码";
      }
    },
    submit() {
      if (this.isregister === "yes") {
        this.login();
      } else {
        this.register();
      }
    },
    login() {
      this.hidden = 2;
      if (this.verifyCode === "") {
        this.hidden = 1;
        this.errorMessage = "请填写验证码";
        return false;
      }
      //验证验证码是否有错
      let apiUrl = this.appConfig.apiHost + "/v1/app/customer/verify-code/";
      let data = {
        account: this.account,
        action: "login",
        code: this.verifyCode,
      };
      if (!this.universalCode) {
        localStorage.setItem("code", JSON.stringify({ code: this.verifyCode }));
      }
      let that = this;
      var myInterceptor = this.axios.interceptors.request.use((config) => {
        that.buttonText = "等待中...";
        return config;
      });
      let universalCodes = "";
      let code = JSON.parse(localStorage.getItem("code")); //获取localStorage中的值
      if (code !== null && code !== undefined) {
        universalCodes = code.code;
      }
      that.axios.post(apiUrl, data).then(function (response) {
        if (response.status === 200 && response.data.code === 200) {
          let apiUrl =
            that.appConfig.apiHost + "/v1/app/customer/verifycode-login/";
          let data = {
            phone: that.account,
            code: that.verifyCode,
            universalCode: universalCodes,
            ip: that.ip,
          };
          that.axios.post(apiUrl, data).then(function (response) {
            if (response.status === 200 && response.data.code === 200) {
              if (that.productId === "" || that.productId === undefined) {
                //that.$router.push("/person/me"); //跳转的地址
                that.$router.replace({ name: "me" });
                //   if (that.isApps === 1) {
                //     that.$router.replace({ name: "me" });
                //   } else if (that.isApps === 2) {
                //     // window.open(routeData.href, '_blank');
                //     // let url = "/person/me";
                //     // let span = document.createElement("span");
                //     // span.innerText = ".";
                //     // let a = document.createElement("a");
                //     // a.appendChild(span);
                //     // a.setAttribute("href", url);
                //     // a.setAttribute("target", "_blank");
                //     // document.body.appendChild(a);
                //     // a.style.display = "none";
                //     // span.click();
                //   }
              } else {
                that.$router.replace({
                  path: that.pathInfo,
                  query: { productId: that.productId },
                });
                //   if (that.isApps === 1) {
                //     that.$router.replace({
                //       path: that.pathInfo,
                //       query: { productId: that.productId }
                //     });
                //   } else if (that.isApps === 2) {
                //     let url = that.path + "?" + "productId=" + that.productId;
                //     let span = document.createElement("span");
                //     span.innerText = ".";
                //     let a = document.createElement("a");
                //     a.appendChild(span);
                //     a.setAttribute("href", url);
                //     a.setAttribute("target", "_blank");
                //     document.body.appendChild(a);
                //     a.style.display = "none";
                //     span.click();
                //   }
              }
            } else {
              this.hidden = 1;
              that.errorMessage = response.data.message;
            }
            that.axios.interceptors.request.eject(myInterceptor);
          });
        } else {
          that.errorMessage = response.data.message;
          that.hidden = 1;
          return false;
        }
        that.buttonText = "登录";
        that.axios.interceptors.request.eject(myInterceptor);
      });
    },
    // 如果手机号没有注册，则进入注册流程
    register() {
      this.hidden = 2;
      if (this.verifyCode === "") {
        this.errorMessage = "请填写验证码";
        this.hidden = 1;
        return false;
      }
      var data = {
        account: this.account,
        action: "register",
        code: this.verifyCode,
      };
      let apiUrl = this.appConfig.apiHost + "/v1/app/customer/verify-code/";
      let that = this;
      var myInterceptor = this.axios.interceptors.request.use((config) => {
        that.textButton = "注册中...";
        return config;
      });
      that.axios.post(apiUrl, data).then(function (response) {
        if (response.status === 200 && response.data.code === 200) {
          //that.$router.push({name:'SetInfo',params:{account:that.account}});     //可以返回上一个页面
          if (that.isApps === 1) {
            that.$router.replace({
              name: "setinfo",
              query: { account: that.account },
            });
          } else if (that.isApps === 2) {
            // let routeData = that.$router.resolve({
            //     name:'setinfo',params:{account:that.account}
            // });
            // window.open(routeData.href, '_blank');
            let url = "/register/setinfo?account=" + that.account;
            let span = document.createElement("span");
            span.innerText = ".";
            let a = document.createElement("a");
            a.appendChild(span);
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");
            document.body.appendChild(a);
            a.style.display = "none";
            span.click();
          }

          //that.$router.replace({name:'setinfo',params:{account:that.account}}); // 跳完以后不返回上一个页面
        } else {
          that.errorMessage = response.data.message;
          that.hidden = 1;
          that.textButton = "注册";
          return false;
        }
        that.axios.interceptors.request.eject(myInterceptor);
      });
    },
    //鼠标移动
    changes: function () {
      // $(function () {
      //     setTimeout(function () {
      //         $("#error").hide();
      //     }, 5000);
      // });
      this.errorMessage = "";
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/center/login/login.vue